import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=98ba1a82"
import script from "./InformationCard.vue?vue&type=script&lang=ts"
export * from "./InformationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98ba1a82')) {
      api.createRecord('98ba1a82', component.options)
    } else {
      api.reload('98ba1a82', component.options)
    }
    module.hot.accept("./InformationCard.vue?vue&type=template&id=98ba1a82", function () {
      api.rerender('98ba1a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InformationCard.vue"
export default component.exports